export default __webpack_public_path__ + "static/media/lc_unselect.cbeacd29.png";